import type { IMakeWinnerScenarioRule } from '../types';

import { ProviderSource, TemplateType } from '~/types/template';
import { EMakeWinnerOperator } from '../types';

export enum EMakeWinnerScenario {
  // Product
  CONTROL_GP_PRODUCT_VS_VARIANT_GP = 'CONTROL_GP_PRODUCT_VS_VARIANT_GP',
  CONTROL_SHOPIFY_PRODUCT_VS_VARIANT_GP = 'CONTROL_SHOPIFY_PRODUCT_VS_VARIANT_GP',
  CONTROL_GP_PRODUCT_VS_VARIANT_SHOPIFY = 'CONTROL_GP_PRODUCT_VS_VARIANT_SHOPIFY',

  //Non Product
  CONTROL_GP_NON_PRODUCT_VS_VARIANT_GP = 'CONTROL_GP_NON_PRODUCT_VS_VARIANT_GP',

  // Home
  CONTROL_GP_HOME_VS_VARIANT_SHOPIFY = 'CONTROL_GP_HOME_VS_VARIANT_SHOPIFY',
  CONTROL_SHOPIFY_HOME_VS_VARIANT_SHOPIFY = 'CONTROL_SHOPIFY_HOME_VS_VARIANT_SHOPIFY',
  CONTROL_SHOPIFY_HOME_VS_VARIANT_GP = 'CONTROL_SHOPIFY_HOME_VS_VARIANT_GP',

  // Landing
  CONTROL_GP_LANDING_VS_VARIANT_SHOPIFY = 'CONTROL_GP_LANDING_VS_VARIANT_SHOPIFY',
  CONTROL_SHOPIFY_LANDING_VS_VARIANT_GP = 'CONTROL_SHOPIFY_LANDING_VS_VARIANT_GP',

  // Collection
  CONTROL_GP_COLLECTION_VS_VARIANT_SHOPIFY = 'CONTROL_GP_COLLECTION_VS_VARIANT_SHOPIFY',
  CONTROL_SHOPIFY_COLLECTION_VS_VARIANT_GP = 'CONTROL_SHOPIFY_COLLECTION_VS_VARIANT_GP',

  // Blog
  CONTROL_SHOPIFY_BLOG_POST_VS_VARIANT_GP = 'CONTROL_SHOPIFY_BLOG_POST_VS_VARIANT_GP',
}

export const GP_PROVIDER_SOURCES = [ProviderSource.GEMPAGESV6, ProviderSource.GEMPAGESV7];
export const SHOPIFY_PROVIDER_SOURCES = [
  ProviderSource.SHOPIFY,
  ProviderSource.SHOPIFY_ORIGIN,
  ProviderSource.SHOPIFY_GEMX,
];

export const MAKE_WINNER_SCENARIO_RULES: IMakeWinnerScenarioRule[] = [
  // Product
  {
    templateType: TemplateType.PRODUCT,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_PRODUCT_VS_VARIANT_GP,
  },
  {
    templateType: TemplateType.PRODUCT,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_PRODUCT_VS_VARIANT_GP,
  },
  {
    templateType: TemplateType.PRODUCT,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: SHOPIFY_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_PRODUCT_VS_VARIANT_SHOPIFY,
  },

  // Home
  {
    templateType: TemplateType.HOME,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: SHOPIFY_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_HOME_VS_VARIANT_SHOPIFY,
  },
  {
    templateType: TemplateType.HOME,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: SHOPIFY_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_HOME_VS_VARIANT_SHOPIFY,
  },
  {
    templateType: TemplateType.HOME,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_HOME_VS_VARIANT_GP,
  },

  // Landing / Page
  {
    templateType: TemplateType.PAGE,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: SHOPIFY_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_LANDING_VS_VARIANT_SHOPIFY,
  },
  {
    templateType: TemplateType.PAGE,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_LANDING_VS_VARIANT_GP,
  },

  // Collection
  {
    templateType: TemplateType.COLLECTION,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: SHOPIFY_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_COLLECTION_VS_VARIANT_SHOPIFY,
  },
  {
    templateType: TemplateType.COLLECTION,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_COLLECTION_VS_VARIANT_GP,
  },

  // Blog
  {
    templateType: TemplateType.ARTICLE,
    controlProviderSource: SHOPIFY_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_SHOPIFY_BLOG_POST_VS_VARIANT_GP,
  },

  //Non Product
  {
    templateType: TemplateType.PRODUCT,
    controlProviderSource: GP_PROVIDER_SOURCES,
    variantProviderSource: GP_PROVIDER_SOURCES,
    scenario: EMakeWinnerScenario.CONTROL_GP_NON_PRODUCT_VS_VARIANT_GP,
    operator: EMakeWinnerOperator.IS_NOT,
  },
];
